import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { CascadingSchemePayload, CascadingSchemeResponse } from "@/types/interface/cascading-scheme";

async function createCascadingScheme(payload: CascadingSchemePayload) {
  return await http.post<APIResponse<CascadingSchemeResponse>>("cascading-scheme/create", payload);
}

async function updateCascadingScheme(idCascadingScheme = '', payload: CascadingSchemePayload) {
  return await http.patch<APIResponse<CascadingSchemeResponse>>(`cascading-scheme/update?id=${idCascadingScheme}`, payload);
}

async function getCascadingScheme(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<CascadingSchemeResponse>>(`cascading-scheme?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findCascadingScheme(idCascadingScheme = "") {
  return await http.get<APIResponse<CascadingSchemeResponse>>(`cascading-scheme/detail?id=${idCascadingScheme}`);
}

async function deleteCascadingScheme(idCascadingScheme = "") {
  return await http.delete<APIResponse<CascadingSchemeResponse>>(`cascading-scheme/delete?id=${idCascadingScheme}`);
}

export default {
  createCascadingScheme,
  updateCascadingScheme,
  getCascadingScheme,
  findCascadingScheme,
  deleteCascadingScheme
};